import m from 'mithril'

export default m.trust(`
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 2L1 13M13 2L15 13" stroke="white" stroke-opacity="0.4" stroke-linecap="round"/>
<path d="M8 2.5V12" stroke="white" stroke-opacity="0.8" stroke-linecap="round" stroke-dasharray="1 3"/>
</svg>
`)